import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _get from "lodash/get";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ImpressionContext, useImpression } from '@nerdwallet/analytics/react/impression';
import { getApplyLink, getInstitutionId, getOfferId, getProductId, getProductType } from '@nerdwallet/marketplace/selectors/common';
import MarketplaceProductCard from './marketplace-product-card';
import { getMonetizable } from './lib/utils';
/**
 *
 * Since the main reason is for product impression and the product impression
 * does not require an entityName we use the hook instead and also do not
 * require the entityName
 */

export var BaseProductCardImpression = function BaseProductCardImpression(_ref) {
  var children = _ref.children,
      marketplaceEntity = _ref.marketplaceEntity,
      productImpressionProps = _ref.productImpressionProps;

  var payload = productImpressionProps.payload,
      rest = _objectWithoutProperties(productImpressionProps, ["payload"]);

  var impressionContext = useContext(ImpressionContext);

  var _useImpression = useImpression({
    eventType: 'product_impression',
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      destination_url: getApplyLink(marketplaceEntity),
      marketplace_institution_id: getInstitutionId(marketplaceEntity),
      marketplace_offer_id: getOfferId(marketplaceEntity),
      marketplace_product_id: getProductId(marketplaceEntity),
      marketplace_product_type: getProductType(marketplaceEntity),
      monetizable: getMonetizable(marketplaceEntity),
      parent_impression_id: _get(payload, 'parent_impression_id', impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId)
    }),
    refireOnEventChange: true
  }),
      ref = _useImpression.ref,
      impression = _objectWithoutProperties(_useImpression, ["ref"]);

  return /*#__PURE__*/React.createElement(ImpressionContext.Provider, {
    value: impression
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest), children));
};
BaseProductCardImpression.propTypes = {
  children: PropTypes.node,
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  productImpressionProps: PropTypes.shape({
    payload: PropTypes.shape({
      element_position: PropTypes.number,
      section_name: PropTypes.string,
      section_position: PropTypes.number
    })
  })
};

var MarketplaceProductCardImpression = function MarketplaceProductCardImpression(props) {
  return /*#__PURE__*/React.createElement(BaseProductCardImpression, _extends({}, props.analytics, {
    marketplaceEntity: props.marketplaceEntity
  }), /*#__PURE__*/React.createElement(MarketplaceProductCard, props));
};

MarketplaceProductCardImpression.propTypes = _objectSpread(_objectSpread({}, MarketplaceProductCard.propTypes), {}, {
  analytics: PropTypes.shape(_objectSpread({
    productImpressionProps: PropTypes.shape({
      payload: PropTypes.shape({
        element_position: PropTypes.number,
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    })
  }, MarketplaceProductCard.propTypes.analytics))
});
export default MarketplaceProductCardImpression;